export default "__VITE_ASSET__4dd6ae1d__"